import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
	// {
	// 	path: "/",
	// 	redirect: '/report/Sales Summary',
	// },
	{
		path : "/",
		name : "Order",
		component: () => import("@/views/portal/Order.vue"),
		meta: {
			requiresAuth: true,
			hasHeader:true
		}
	},
	{
		path : "/order/:orderId",
		name : "OrderDetail",
		component: () => import("@/views/portal/OrderDetail.vue"),
		meta: {
			requiresAuth: true,
			hasHeader:true
		}
	},
	{
		path: "/report/:report",
		name: "Home",
		component: () => import("@/views/portal/Home.vue"),
		meta: {
			requiresAuth: true,
			hasHeader:true
		}
	},
	{
		path: "/square-setup",
		name: "SquareSetup",
		component: () => import("@/views/portal/SquareSetup.vue"),
		meta: {
			requiresAuth: true,
			hasHeader:true
		}
	},
	{
		path: "/stripe-setup",
		name: "StripeSetup",
		component: () => import("@/views/portal/StripeSetup.vue"),
		meta: {
			requiresAuth: true,
			hasHeader:true
		}
	},
	{
		path: "/users",
		name: "Users",
		component: () => import("@/views/portal/Users.vue"),
		meta: {
			requiresAuth: true,
			hasHeader:true
		}
	},
	{
		path: "/locations",
		name: "Locations",
		component: () => import("@/views/portal/Locations.vue"),
		meta: {
			requiresAuth: true,
			hasHeader:true
		}
	},
	{
		path: "/organizations",
		name: "Organizations",
		component: () => import("@/views/portal/Organizations.vue"),
		meta: {
			requiresAuth: true,
			hasHeader:true
		}
	},
	{
		path: "/menu-setup",
		name: "Menu Setup",
		component: () => import("@/views/portal/MenuSetup.vue"),
		meta: {
			requiresAuth: true,
			hasHeader:true
		}
	},
	{
		path: "/list86",
		name: "List86",
		component: () => import("@/views/portal/List86.vue"),
		meta: {
			requiresAuth: true,
			hasHeader:true
		}
	},
	{
		path: "/menu-editor",
		name: "Menu Editor",
		component: () => import("@/views/portal/MenuEditor.vue"),
		meta: {
			requiresAuth: true,
			hasHeader:true
		}
	},
	{
		path: "/menu-preview",
		name: "Menu Preview",
		component: () => import("@/views/portal/MenuPreview.vue"),
		meta: {
			requiresAuth: true,
			hasHeader:false
		}
	},
	{
		path: "/settings",
		name: "Setting",
		component: () => import("@/views/portal/Settings.vue"),
		meta: {
			requiresAuth: true,
			hasHeader:false
		}
	},
	{
		path: "/profile",
		name: "Profile",
		component: () => import("@/views/portal/Profile.vue"),
		meta: {
			requiresAuth: true,
			hasHeader:true
		}
	},
	{
		path: "/dashboard",
		name: "Dashboard",
		component: () => import("@/views/portal/Dashboard.vue"),
		meta: {
			requiresAuth: true,
			hasHeader:true
		}
	},
	{
		path: "/photo-library",
		name: "Photo Library",
		component: () => import("@/views/portal/PhotoLibrary.vue"),
		meta: {
			requiresAuth: true,
			hasHeader:true
		}
	}
	
];

const router = new VueRouter({
	mode: "hash",
	routes	
});

router.beforeEach((to, from, next) => {
	next()
})
export default router;
